import React from "react";

export default function BarChart({ data, color = "#1a73e8", height = 160, colorFn, orientation = "vertical", valueFormatter }) {
  const max = Math.max(...data.map((d) => d.value), 1) * 1.1;
  const fmt = valueFormatter || ((v) => v);

  if (orientation === "horizontal") {
    return (
      <div className="space-y-3">
        {data.map((d, i) => {
          const pct = (d.value / max) * 100;
          const barColor = colorFn ? colorFn(d) : color;
          return (
            <div key={i} className="flex items-center gap-3">
              <span className="w-24 text-xs text-[#5f6368] dark:text-[#9aa0a6] shrink-0 truncate">{d.label}</span>
              <div className="flex-1 h-3 rounded-full bg-[#f1f3f4] dark:bg-[#202124] overflow-hidden">
                <div className="h-full rounded-full transition-all duration-500" style={{ width: `${pct}%`, backgroundColor: barColor }} />
              </div>
              <span className="w-14 text-xs font-semibold text-[#202124] dark:text-[#e8eaed] text-right shrink-0">{fmt(d.value)}</span>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <div className="flex items-end justify-between gap-2" style={{ height }}>
      {data.map((d, i) => {
        const h = Math.max(3, (d.value / max) * 100);
        const barColor = colorFn ? colorFn(d) : color;
        return (
          <div key={i} className="flex-1 h-full flex flex-col items-center justify-end gap-1.5">
            <span className="text-[10px] font-semibold text-[#3c4043] dark:text-[#dadce0]">{fmt(d.value)}</span>
            <div className="w-full flex-1 flex items-end justify-center">
              <div className="w-full max-w-[36px] rounded-t-lg transition-all duration-500" style={{ height: `${h}%`, backgroundColor: barColor }} />
            </div>
            <span className="text-[10px] text-[#9aa0a6] text-center">{d.label}</span>
          </div>
        );
      })}
    </div>
  );
}
